import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import DxDiagnosisIntroduction from '@src/features/company/dx-diagnosis/DxDiagnosisIntroduction';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyDxDiagnosisIntroduction() {
  return (
    <CompanyGuard canService={[SERVICE.DX_DIAGNOSIS]}>
      <CompanyDefaultLayout pageName='dx-diagnosis'>
        <CommonHelmet />
        <DxDiagnosisIntroduction />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyDxDiagnosisIntroduction;
